import styled from 'styled-components'

import theme from '~/shared/styles/theme'

interface Props {
  tabContents: string[]
  selectedTab: number
  $size: 'sm' | 'md'
  setSelectTab: (tab: number) => void
}

function Tabs({ tabContents, selectedTab, setSelectTab, ...rest }: Props) {
  return (
    <Wrapper {...rest}>
      {tabContents.map((tabContent, index) => (
        <Tab
          key={index}
          $isactived={index === selectedTab}
          onClick={() => setSelectTab(index)}
        >
          {tabContent}
        </Tab>
      ))}
    </Wrapper>
  )
}

export default Tabs

const Wrapper = styled.div<{ $size: 'sm' | 'md' }>`
  display: flex;
  flex-direction: row;
  gap: 42px;

  height: 36px;
  margin-top: 80px;

  ${({ $size }) => {
    if ($size === 'sm') {
      return `
        font-size: 18px;
      `
    }

    return `
        font-size: 24px;
    `
  }}

  @media ${theme.device.large} {
    margin-top: 100px;
  }

  @media ${theme.device.medium} {
    margin-top: 38px;
  }
`

const Tab = styled.div<{ $isactived: boolean }>`
  cursor: pointer;

  display: flex;
  align-items: start;
  justify-content: center;

  color: ${theme.colors.grey_4};

  ${({ $isactived }) => {
    if ($isactived) {
      return `
        font-family: NanumSquareNeo-Heavy, sans-serif;
        border-bottom: 5px solid ${theme.colors.black};
        color: ${theme.colors.black};
      `
    }

    return `
        font-family: NanumSquareNeo-Bold, sans-serif;
    `
  }}

  @media ${theme.device.medium} {
    font-size: 18px;
  }
`
